<script>
import UmTableRole from '@/components/UmTableRole'
import { apiOrganRoleAppPermissionCommit, apiOrganRolePermissionTree } from '@/api/enterprise'

export default {
  name: 'AuthManage',
  components: { UmTableRole },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    roleUuid: {
      type: String,
      default: ''
    },
    moduleData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      moduleDataList: [],
      roleModuleTree: [],
      appPermissionList: []
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      }
    }
  },
  watch: {
    visible: {
      handler(show) {
        if (show) {
          this.getAuthTree()
        }
      }
    }
  },
  created() {},
  methods: {
    async getAuthTree() {
      try {
        this.loading = true
        const moduleCodeList = this.moduleData.map(i => i.moduleCode)
        if (moduleCodeList.length === 0) return
        const res = await apiOrganRolePermissionTree({
          roleUuid: this.roleUuid,
          moduleCodeList
        })
        this.roleModuleTree = res.data
        const moduleDataList = []
        this.moduleData.forEach((item) => {
          const data = { ...item }
          const roleData = res.data.find(i => i.sysModuleCode === item.moduleCode)
          if (roleData) {
            data.roleData = [roleData]
          }
          moduleDataList.push(data)
        })
        this.moduleDataList = moduleDataList
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async saveAuth() {
      try {
        this.loading = true
        const moduleCodeList = this.moduleData.map(item => {
          return {
            appUuid: item.appUuid,
            moduleCode: item.moduleCode,
            moduleCodeList: this.$refs[item.appUuid][0].getCheckData()
          }
        })
        const res = await apiOrganRoleAppPermissionCommit({
          roleUuid: this.roleUuid,
          appPermissionList: moduleCodeList
        })
        this.$message.success(res.msg)
        this.visible = false
        this.$emit('submit')
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <el-dialog
    title="应用权限管理"
    :visible.sync="visible"
    width="80%"
    append-to-body
    destroy-on-close
  >
    <div v-loading="loading" class="auth-role-table">
      <template v-for="item in moduleDataList">
        <um-table-role
          :ref="item.appUuid"
          :key="item.appUuid"
          :table-name="item.appName"
          show-head
          :tree-data="item.roleData"
        />
      </template>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" :disabled="loading" @click="saveAuth">保 存</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss">
.auth-role-table{
  height: 500px;
  overflow: auto;
}
</style>
